import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Form } from "react-bootstrap";
import * as actions from "Store/Course/Instructor/OtherLabs/Actions";
// import Options from "../Options";
import parse from 'html-react-parser';
import '../../css/fillInBlanks.scss';
import AnswerExplanation from "../../GradeSubmission/AnswerExplaination";
import { removeRemarks } from "../../GradeSubmission/GradeCheck";
// import log from "loglevel";

const FillBlanks = ({ courseId, question, index, previousResponse, updateResponse, disable, Eval }) => {
  const [questionResponseId, setQuestionResponseId] = useState(null);
  const [saveResponseTimer, setSaveResponseTimer] = useState(null);
  const [userAnswerText, setUserAnswerText] = useState("");
  const mode = localStorage.getItem("mode");

  const formatAnswerArray = (answerString) =>
    answerString.replace(/'/g, '').split(',').map(answer => answer.trim().toLowerCase());

  const expectedAnswersList = question.questionanswer_set.map(ans => formatAnswerArray(ans.answer));
  const primaryAnswerList = formatAnswerArray(question.questionanswer_set[0].answer);

  const validateUserAnswer = useCallback((responseText) => {
    if (!responseText) return { isSingleAnswerCorrect: false, isMultiAnswerCorrect: false };

    const userAnswers = responseText.trim().toLowerCase().split('\n');
    const isSingleAnswerCorrect = primaryAnswerList.includes(responseText.trim().toLowerCase());
    const isMultiAnswerCorrect = userAnswers.every((answer, idx) =>
      expectedAnswersList[idx]?.includes(answer.trim())
    );

    return { isSingleAnswerCorrect, isMultiAnswerCorrect };
  }, [primaryAnswerList, expectedAnswersList]);

  useEffect(() => {
    if (previousResponse) {
      if (!questionResponseId) setQuestionResponseId(previousResponse.id || null);
      setUserAnswerText(previousResponse.response_text || "");
    }
  }, [previousResponse]);

  const saveUserResponse = async (text) => {
    if (!disable) {
      const response = await actions.addQuestionResponsesRequest(courseId, question, null, text, questionResponseId, null);
      if (response) {
        setQuestionResponseId(response.id);
        updateResponse({ ...response, id: question.id });
      }
    }
  };

  const handleUserTyping = (value) => {
    clearTimeout(saveResponseTimer);
    setUserAnswerText(value);
    setSaveResponseTimer(setTimeout(() => saveUserResponse(value), 1000));
  };

  const saveScoredMarks = async (marks) => {
    await actions.addScoredMarksRequest(question, questionResponseId, marks);
    updateResponse();
  };

  const saveRemark = async (remark) => {
    await actions.addRemarkRequest(question, questionResponseId, remark);
    updateResponse();
  };

  const renderQuestionText = () => {
    const sanitizedQuestionText = removeRemarks(question?.question_text);
    return (
      <Col xs={12} className="question-text">
        <b>{parse(sanitizedQuestionText)}</b>
      </Col>
    );
  };

  const renderAnswerInput = ({ isSingleAnswerCorrect, isMultiAnswerCorrect }) => {
    const answerValidationStyle = Eval
      ? (isSingleAnswerCorrect || isMultiAnswerCorrect || question?.questionresponse_set?.scored_marks === question?.marks)
        ? '2px solid green'
        : question?.questionresponse_set?.scored_marks > 0
          ? '2px solid orange'
          : '2px solid red'
      : {};

    return (
      <Col xs={12}>
        <div style={{ border: answerValidationStyle }}>
          <Form.Control
            type="text"
            value={userAnswerText}
            onChange={({ target: { value } }) => handleUserTyping(value)}
            disabled={disable}
          />
        </div>
      </Col>
    );
  };

  const renderEvaluationSection = ({ isSingleAnswerCorrect, isMultiAnswerCorrect }) => {
    if (!disable) return null;

    return (
      <>
        <Col xs={6}></Col>
        <Col xs={6}>
          <Form.Check>
            <Form.Label>Scored Marks</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={
                (isSingleAnswerCorrect || isMultiAnswerCorrect || question?.questionresponse_set?.scored_marks > 0) && Eval || mode === "I"
                  ? question?.questionresponse_set?.scored_marks
                  : (question?.questionresponse_set?.scored_marks || 0)
              }
              step="0.1"
              disabled
            />
          </Form.Check>
          {(Eval || mode === "I") && (
            <div style={{ marginRight: '-100px', marginTop: '-40px', marginLeft: '-450px' }}>
              <AnswerExplanation explanation={question?.answer_explaination} />
            </div>
          )}
        </Col>
      </>
    );
  };

  const { isSingleAnswerCorrect, isMultiAnswerCorrect } = validateUserAnswer(previousResponse?.response_text || "");

  return (
    <Row className="fill-blanks-component" style={{ margin: '0 10px' }}>
      <Col xs={12} style={{ marginBottom: 10 }}>
        <div className="question-header d-flex justify-content-between align-items-center">
          <b>
            <i>
              <span style={{ fontSize: 20, color: 'rgb(41, 121, 255)' }}>{`Question ${index + 1}`}</span>
            </i>
          </b>
          <span className="question-meta text-primary">
            <b>
              <i>
                Question Type: {question.question_type === 'F' ? 'FILL_BLANK' : ''}
                <span style={{ marginLeft: '40px' }}>Marks: {question.marks}</span>
              </i>
            </b>
          </span>
        </div>
      </Col>
      {renderQuestionText()}
      {renderAnswerInput({ isSingleAnswerCorrect, isMultiAnswerCorrect })}
      {renderEvaluationSection({ isSingleAnswerCorrect, isMultiAnswerCorrect })}
    </Row>
  );
};

export default FillBlanks;
